import { render, staticRenderFns } from "./TaxInvoice.vue?vue&type=template&id=84bee638&scoped=true&"
import script from "./TaxInvoice.vue?vue&type=script&lang=js&"
export * from "./TaxInvoice.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TaxInvoice.vue?vue&type=style&index=1&id=84bee638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bee638",
  null
  
)

export default component.exports